import React from 'react';
import SimpleModal from 'components/global/SimpleModal';
import { handleSubmitCreateRoom } from 'components/views/FounderRooms/_helpers/founderRooms.events';
import { $view } from 'signals/global.signals';
import { handleHideModal } from 'components/global/_helpers/global.helpers';
import FounderRoomForm from './FounderRoomForm';

const FounderCreateRoundModal = () => (
  <SimpleModal
    show={$view.value?.activeModal === 'founder-room-create'}
    title="Create Room"
    isLoading={$view.value?.isModalLoading}
    onHide={handleHideModal}
    onPrimaryClick={handleSubmitCreateRoom}
    primaryButtonText="Save"
    secondaryButtonText="Cancel"
    onSecondaryClick={handleHideModal}
    size="xl"
  >
    <FounderRoomForm />
  </SimpleModal>
);

export default FounderCreateRoundModal;
